/** Shared bootstrap and prerender allowlist. No application or auth imports. */
export const PUBLIC_PATHS = [
  "/",
  "/pricing",
  "/vs/liveheats",
  "/vs/the-boardr",
  "/vs/stact",
  "/results/demo",
  "/terms",
  "/privacy",
  "/refunds",
] as const;
export type PublicPath = (typeof PUBLIC_PATHS)[number];
export function publicPathname(path: string): string {
  return path.length > 1 ? path.replace(/\/+$/, "") : path;
}
export function isPublicPath(path: string): path is PublicPath {
  return (PUBLIC_PATHS as readonly string[]).includes(path);
}
